module.exports = __webpack_public_path__ + "static/media/smile.fd91b062.svg";